<template>
  <div class="up-region-picker">
    <up-region-picker-panel
      class="up-region-picker__panel"
      :data="datasource"
      :province="province"
      :title="title"
      v-model="selectedData"
    ></up-region-picker-panel>
    <up-region-picker-selected
      class="up-region-picker__selected"
      v-model="selectedData"
      @selected="handleSelected"
      :isSelectAll="isSelectAll"
    ></up-region-picker-selected>
  </div>
</template>

<script>
import RegionPickerPanel from './panel'
import RegionPickerSelected from './selected'

export default {
  name: 'UpRegionPicker',

  components: {
    [RegionPickerPanel.name]: RegionPickerPanel,
    [RegionPickerSelected.name]: RegionPickerSelected
  },

  props: {
    datasource: {
      type: Array,
      default: () => []
    },
    isSelectAll: {
      type: Boolean,
      default: () => true
    },
    title: {
      type: Object,
      default: () => { }
    },
    value: {},
    formatedValue: { // 默认值
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      // data: this.datasource,
      province: '',
      selectedData: []
    }
  },

  watch: {
    // datasource (newVal) {
    //   this.data = newVal
    // },
    value (newVal) {
      // if (!newVal || !Array.isArray(newVal)) return
      this.selectedData = newVal
    },
    datasource (newVal) {
      if (!Object.keys(this.formatedValue).length) return
      this.selectedData = this.getSelectedData(newVal, this.formatedValue)
    },
    formatedValue: {
      handler (newVal) {
        if (!this.datasource.length) return
        this.selectedData = this.getSelectedData(this.datasource, newVal)
      },
      immediate: true
    },
    selectedData: {
      handler (newVal) {
        this.$emit('input', newVal)
        this.$emit('change', {
          original: newVal,
          formated: newVal.reduce((acc, val) => {
            acc[val.value] = val.children ? val.children.map(v => v.value) : [val.value]
            return acc
          }, {})
        })
      },
      deep: true
    }
  },

  methods: {
    handleSelected (item) {
      this.province = item.province
    },
    getSelectedData (datasource, formatedValue) {
      return Object.keys(formatedValue).reduce((acc, key) => {
        const province = datasource.find(item => item.value === key)
        if (province && province.children.find(item => formatedValue[key].indexOf(item.value) > -1)) {
          if (province.children && province.children.length === formatedValue[key].length || !province.children) {
            acc.push({
              ...province,
              isAll: true
            })
          } else {
            acc.push({
              ...province,
              children: province.children.filter(item => formatedValue[key].indexOf(item.value) > -1),
              isAll: false
            })
          }
        }
        return acc
      }, [])
    }

  }
}
</script>

<style lang="scss">
@include b(up-region-picker) {
  display: flex;
  font-size: 14px;

  @include e(header) {
    height: 40px;
    padding: 0 15px;
    border-bottom: 1px solid #ebeef5;
    box-sizing: border-box;
    line-height: 40px;
    color: #606266;
    background: #f5f7fa;
  }

  @include e(panel) {
    // flex: 0 1 496px;
    width: 540px;
  }

  @include e(selected) {
    margin-left: 72px;
  }
}
</style>
